import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  mainContainer: {
    width: "90%",
    display: "flex",
    maxWidth: "1280px",
    marginTop: "93px",
    fontFamily: "Trebuchet",
    marginLeft: "auto",
    marginRight: "auto",
    justifyContent: "center",
    paddingTop: "90px",
    paddingBottom: "90px",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      width: "92%"
    },
    [theme.breakpoints.down("sm")]: {
      width: "70%"
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
      paddingTop: "20px",
      paddingBottom: "50px"
    }
  },
  titleError404: {
    fontSize: "42px",
    fontWeight: 800,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#000000",
    marginBottom: 15,
    [theme.breakpoints.down("sm")]: {
      fontSize: "38px"
    }
  },
  subtitleError404: {
    fontSize: "26px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.23",
    letterSpacing: "normal",
    color: "#000000",
    marginBottom: 15,
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px"
    }
  },
  descriptionError404: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.3",
    letterSpacing: "normal",
    color: "#8c8c8c",
    marginBottom: 25,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px"
    }
  },
  buttonStyle: {
    borderRadius: "5px",
    backgroundColor: "#449bff",
    width: "181px",
    height: "40px",
    fontSize: 15,
    fontWeight: "bold",
    textTransform: "inherit",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 15
    }
  },
  infoContainer: {
    maxWidth: 500,
    marginBottom: 50
  },
  infoButtonContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column"
    }
  },
  titleAppSaludsa: {
    fontSize: "26px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.04",
    letterSpacing: "normal",
    color: "#0073cf",
    maxWidth: 180,
    marginBottom: 15,
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px"
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: 150
    }
  },
  error404Image: {
    marginRight: 15
  },
  buttonAppMargin: {
    marginRight: 15,
    [theme.breakpoints.down("xs")]: {
      width: 120,
      marginBottom: 8,
      marginRight: 0
    }
  },
  phoneLinksAppContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 25
  },
  appInfoContainer: {
    display: "flex",
    position: "relative",
    marginBottom: 25,
    [theme.breakpoints.down("xs")]: {
      alignItems: "center"
    }
  },
  lineAppContainer: {
    position: "absolute",
    width: "490px",
    margin: "0",
    bottom: "0",
    padding: "0",
    marginBlock: "0",
    [theme.breakpoints.down("xs")]: {
      width: "90%"
    }
  },
  telfContainer: {
    fontSize: "22px",
    fontWeight: 300,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#8c8c8c",
    marginLeft: 15,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px"
    }
  },
  wpContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: 15
  }
}));

export default styles;
